@if (showLabel) {
  <label class="form-label" [attr.for]="id">{{ labelKey | translate }}</label>
}
<div class="d-flex align-items-center gap-2" [class.flex-row-reverse]="isPickerOnRight">
  <input
    [id]="id"
    ejs-colorpicker
    type="color"
    [value]="pickerValue"
    mode="Palette"
    [showButtons]="false"
    [noColor]="true"
    [enableOpacity]="false"
    (change)="onColorPickerChanged($event)" />
  @if (showValueInput) {
    <input
      [id]="id + 'Hex'"
      type="text"
      class="form-control"
      [value]="value ?? ''"
      [placeholder]="placeholder"
      maxlength="7"
      (input)="onHexInput($event)" />
  }
</div>
@if (showValueInput && showHint) {
  <small class="text-body-secondary d-block mt-1">{{ hintKey | translate }}</small>
}
